import { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { BaseLayout } from '@link/share/layouts';
import { updateThemeColor } from '@link/share/utils';
import Logo from '@link/triplabo/assets/triplabo.svg';
import { SUPPORTED_LOCALE_OPTIONS, DEFAULT_LOCALE } from '@link/triplabo/i18n';
import { SHINKANSEN_THEME_COLOR } from '@link/triplabo/services/shinkansen/consts';
import { useStore } from '@link/triplabo/stores';
import triplaboAuth from '@link/triplabo/vendors/firebase';

const TriplaboLayout = observer(() => {
  const { auth } = useStore();

  useEffect(() => {
    updateThemeColor(SHINKANSEN_THEME_COLOR);
  }, []);

  const logout = useCallback(async () => {
    await triplaboAuth.logout();
  }, []);

  return (
    <BaseLayout
      appLogo={Logo}
      localeList={SUPPORTED_LOCALE_OPTIONS}
      defaultLocale={DEFAULT_LOCALE}
      isPasswordAuth={auth.isPasswordAuth}
      logout={logout}
      loggedIn={auth.loggedIn}
    />
  );
});

export { TriplaboLayout };
